import React, { PureComponent } from "react";
import { DatePicker } from "antd";

const { MonthPicker } = DatePicker;
const MonthPickerHoc = (ParentCom) => {
  return class extends PureComponent {
    constructor(props) {
      super(props);
      this.props = props;
    }

    // 自定义通用form（input关联）hoc
    childItem(placeholder, paramName) {
      // const hoc = this;
      const parentItem = class extends PureComponent {
        render() {
          const props = this.props;
          return <MonthPicker format="YYYY-MM" placeholder={placeholder} {...props} />;
        }
      };
      return parentItem;
    }

    format(coreVal) {
      return coreVal ? coreVal.format("YYYY-MM") : "";
    }
    componentDidMount() {
      // console.log('--monthPicker--',this.props.getInstance);
      if (this.props.getInstance && typeof this.props.getInstance === "function") {
        this.props.getInstance(this.ctx);
      }
    }
    render() {
      const items = [this.childItem.bind(this)];
      // getInstance 获取子组件上下文
      return (
        <ParentCom
          {...this.props}
          monthPicker={items}
          format={this.format}
          getInstance={(ctx) => {
            this.ctx = ctx;
          }}
        />
      );
    }
  };
};

export default MonthPickerHoc;



// WEBPACK FOOTER //
// ./src/AntD/hoc/form/monthPickerHoc.js